import { IDashboardExample } from 'types/GlobalDashboardExample'

export const getUniqueCategories = (
  list: IDashboardExample[],
  lang: 'sv' | 'en'
) => {
  const seen = new Set<string>()
  const out: { value: string; label: string }[] = []

  for (const item of list) {
    const c = item?.category

    if (!c?.slug || !c?.title) continue
    if (seen.has(c.slug)) continue

    seen.add(c.slug)
    out.push({ value: c.slug, label: c.title[lang] })
  }

  return out
}

export const getUniqueSegments = (
  list: IDashboardExample[],
  lang: 'sv' | 'en'
) => {
  const seen = new Set<string>()
  const out: { id: string; title: string }[] = []

  for (const item of list) {
    const segs = item?.segments

    if (!Array.isArray(segs) || segs.length === 0) continue

    for (const s of segs) {
      if (!s?.slug) continue
      if (seen.has(s.slug)) continue

      seen.add(s.slug)
      out.push({ id: s.slug, title: s.title[lang] ?? s.slug })
    }
  }

  return out
}
